import * as React from 'react';

import {FormField} from 'shells/form/form-field';
import {Popover} from 'shells/popover/popover';
import {PopoverForm} from 'shells/popover-form/popover-form';
import {TextField} from 'shells/textfield/textfield';

import type {
    GetProductsCategories_productCategories as ProductCategory,
    ProductCategoryCreateInput,
    ProductCategoryUpdateInput,
} from 'nutshell-graphql-types';

type BaseProps = {
    onClose: () => void;
    isSaving: boolean;
    anchor: HTMLElement | null | undefined;
    errorSaving: string | null | undefined;
};

type CreateProps = BaseProps & {
    variant: 'create';
    onSubmit: (input: ProductCategoryCreateInput) => Promise<any>;
};

type UpdateProps = BaseProps & {
    variant: 'update';
    productCategory: ProductCategory;
    onSubmit: (input: ProductCategoryUpdateInput) => Promise<any>;
};

type Props = CreateProps | UpdateProps;

export function CategoryCreateOrUpdatePopover(props: Props) {
    const [productCategoryName, setProductCategoryName] = React.useState<string>(
        // @ts-expect-error
        (props.productCategory && props.productCategory.name) || ''
    );

    const handleSubmit = () => {
        const submitPromise =
            props.variant === 'create'
                ? props.onSubmit({name: productCategoryName})
                : props.onSubmit({name: productCategoryName, id: props.productCategory.id});

        submitPromise
            .then(() => {
                props.onClose();
            })
            .catch(() => {
                setProductCategoryName('');
            });
    };

    return (
        <Popover anchor={props.anchor} location='bottom' onBlur={props.onClose}>
            <PopoverForm
                title={props.variant === 'create' ? 'New category' : 'Edit category'}
                onClose={props.onClose}
                onSubmit={handleSubmit}
                isSaving={props.isSaving}
                saveButtonText='Save category'
                saveButtonVariant='primary'
                saveButtonDisabled={!productCategoryName.trim()}
                errorSaving={Boolean(props.errorSaving)}
            >
                <div className='py-4'>
                    <FormField innerId='name' label='Name' isRequired={true}>
                        <TextField
                            id='name'
                            // @ts-expect-error
                            name='name'
                            focusOnMount={true}
                            value={productCategoryName}
                            onChange={(value) => setProductCategoryName(value)}
                            errorMessage={props.errorSaving || undefined}
                            hasError={Boolean(props.errorSaving)}
                        />
                    </FormField>
                </div>
            </PopoverForm>
        </Popover>
    );
}
